import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';

export default class OHSVacancies extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            vacancies_array: [],
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        }

        this.datasheetFieldSpecs = [
            { field: 'branch', headerName: 'Branch', width: 200},
            { field: 'number_of_missing_appointments', align: 'center', headerName: '# Vacancies', width: 150},
            { field: 'branch_managers', headerName: 'Manager(s)', width: 400},
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_ohs_vacancies',this.props.gwt)
        .then(reply=>{
            console.log('query_ohs_certificate_flags reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_ohs_vacancies) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_ohs_vacancies) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                if (this.state.filter_applied){
                    this.setState({querying:false, vacancies_array:reply.branch_list? reply.branch_list : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, vacancies_array:reply.branch_list?reply.branch_list : [], filtered_assessments_array:reply.branch_list?reply.branch_list : []});
                }
                
            }
        });
    };
    
    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, vacancies_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'OHS Vacancies ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - OHS Vacancies by Branch ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.vacancies_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.vacancies_array.length > 0){
            let temp_array = [];
            console.log('filterObj :>> ', filterObj);
            switch (filterObj.type) {
                case 'rom':
                    for (const record of this.state.vacancies_array){
                        if (record.branch_managers.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'branch':
                    for (const record of this.state.vacancies_array){
                        if (record.store_code.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:880
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={2}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={8}>
                        <Typography
                            style={{padding:10}}
                        >
                            <b>OHS Role Vacancies by Branch</b><br/>(Branches with one or more required OHS role vacancies)
                        </Typography>
                    </Grid>

                    <Grid item xs={2}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.vacancies_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                show_branch_filter={true}
                                // show_cycle_filter={true}
                                hide_name_filter={true}
                                hide_emp_num_filter={true}
                            />
                        </Grid>
                    </Grid>

                </Grid>


                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:880,maxWidth:880, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}